module.exports = "/_next/static/images/it-d3ad8488c08de9bda74dcda26829fe9a.svg";